
import _ from 'lodash'
const modulesFiles = require.context('./', true, /\.png$/)
// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName =_.trimEnd(modulePath.substr(modulePath.lastIndexOf('/')+1,modulePath.length),'.png')
  const base64 = modulesFiles(modulePath)
  modules.push({
      label:moduleName,
      value:moduleName,
      code:base64
  })
  return modules
}, [])

// console.log(modules)
export default modules


// WEBPACK FOOTER //
// ./src/assets/paramIcon/index.js